import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCogniteLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 55.291,
	id: "Layer_1",
	viewBox: "0 0 94.724739 55.291",
	width: 94.724739,
	x: "0px",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", {
			id: "defs4",
			children: [
				/* @__PURE__ */ _jsx("defs", {
					id: "defs1",
					children: /* @__PURE__ */ _jsx("rect", {
						height: 55.299999,
						id: "SVGID_1_",
						width: 245.60001,
						x: 2.2,
						y: 2.0999999
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					clipPathUnits: "userSpaceOnUse",
					id: "clipPath4",
					children: /* @__PURE__ */ _jsx("use", {
						id: "use4",
						style: { overflow: "visible" },
						transform: "translate(-87.004,9.946)",
						xlinkHref: "#SVGID_1_"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					clipPathUnits: "userSpaceOnUse",
					id: "clipPath5",
					children: /* @__PURE__ */ _jsx("use", {
						id: "use5",
						style: { overflow: "visible" },
						transform: "translate(-67.909,13.494)",
						xlinkHref: "#SVGID_1_"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					clipPathUnits: "userSpaceOnUse",
					id: "clipPath6",
					children: /* @__PURE__ */ _jsx("use", {
						id: "use6",
						style: { overflow: "visible" },
						transform: "translate(-64.302,15.478)",
						xlinkHref: "#SVGID_1_"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					clipPathUnits: "userSpaceOnUse",
					id: "clipPath7",
					children: /* @__PURE__ */ _jsx("use", {
						id: "use7",
						style: { overflow: "visible" },
						transform: "translate(-24.719,9.202)",
						xlinkHref: "#SVGID_1_"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					clipPathUnits: "userSpaceOnUse",
					id: "clipPath8",
					children: /* @__PURE__ */ _jsx("use", {
						id: "use8",
						style: { overflow: "visible" },
						transform: "translate(-36.504,15.891)",
						xlinkHref: "#SVGID_1_"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("style", {
			id: "style1",
			type: "text/css",
			children: "\n	.st0{clip-path:url(#SVGID_2_);}\n"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clipPath8)",
			id: "Group_1",
			transform: "translate(34.304,-18)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M 40.5,40.7 V 36 c 0,-2.3 -1.8,-4.1 -4.1,-4.1 v 0 c -2.3,0 -4.1,1.8 -4.1,4.1 v 0 6.1 c -2.7,0.4 -5.3,1 -8.2,1.4 V 22.1 C 24.1,19.8 22.3,18 19.8,18 v 0 0 c -2.3,0 -4.1,1.8 -4.1,4.1 v 23.5 c -0.2,0 -0.6,0 -0.8,0.2 -2.7,0.6 -4.9,1 -7.4,1.6 V 29.3 C 7.5,27 5.7,25.2 3.4,25.2 v 0 c -2.3,0 -3.9,1.8 -4.1,4.1 v 20.1 c -3.1,0.6 -5.5,1 -8.2,1.4 v -9.2 c 0,-2.3 -1.8,-4.1 -4.1,-4.1 -2.3,0 -4.1,1.8 -4.1,4.1 V 52 c -9.2,1 -14.5,0.8 -15.1,-1 -1.2,-2.9 7.2,-6.8 9.6,-8 v 0 h -0.2 c -2.5,0.8 -12.9,5.1 -11.5,8.8 1.2,4.1 17.2,5.1 50.5,-2.9 27.8,-7 40.7,-8.2 42,-5.5 1,2.3 -5.9,6.5 -12.7,9.4 0,0 -0.2,0.2 -0.2,0.4 0.2,0.2 0.4,0.4 0.6,0.2 C 48.4,52.6 61,47.3 60.4,42.8 59.9,39.7 53.3,38.9 40.5,40.7 m -57.4,19.5 v 3.1 c 0,2.3 1.8,4.1 4.1,3.9 2.3,0 3.9,-1.8 3.9,-3.9 v -4.1 c -2.4,0.6 -5.3,0.8 -8,1 m 16.4,-2.3 v 11.3 c 0,2.3 1.6,4.1 3.9,4.1 v 0 c 2.3,0 4.1,-1.6 4.1,-3.9 V 69.2 56.3 c -2.7,0.6 -5.3,1.2 -8,1.6",
				id: "Path_1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clipPath7)",
			id: "Group_2",
			transform: "translate(22.519,-11.311)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "m 28.1,47.7 h -0.6 v 8 c 0,2.3 2,4.1 4.3,4.1 2.3,0 3.9,-1.8 4.1,-4.1 v -9.8 c -2.5,0.6 -4.9,1 -7.8,1.8 M 43.9,44 v 4.7 c 0,2.3 2,4.1 4.3,4.1 v 0 c 2.3,0 4.1,-1.8 4.1,-4.1 v -6.3 c -2.5,0.6 -5.4,1 -8.4,1.6",
				id: "Path_2"
			})
		})
	]
});
export default SvgCogniteLogoIcon;
